"use client";




export default function Team1() {
  return (
    <section id="team1" className="w-full py-12 lg:py-[4.5rem]">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-start gap-8 px-5 md:px-8 lg:px-0 md:flex-row md:items-start md:justify-between">
        {/* Left Column */}
        <div className="lg:w-1/2">
          <h2 className="text-2xl font-bold sm:text-3xl lg:text-4xl">
            Superior workmanship and
            <br />
            <span className="underline decoration-primary decoration-4 underline-offset-4">
              guaranteed quality.
            </span>
          </h2>
          <h3 className="mt-8 text-sm font-bold sm:text-base"></h3>
          <h3 className="mt-6 text-sm font-bold sm:text-base">
            Decades of trusted experience.
          </h3>
          <p className="mt-4 text-sm text-gray-600 sm:text-base">
            Our corporation has been established since 1989 by Mr. Jim Bishop,
            who is the founder and principal. He has a building sciences
            background, and has accumulated over 25 years of experience in
            contracting, both in Canada and the USA, respectively. Bishop
            Mercier has performed over 10,000 small, middle-sized, and large
            projects, (of residential, industrial, institutional, and commercial
            projects), in both Quebec and Ontario, respectively; and the company
            has performed more than 2000 small, middle-sized, and large sized
            projects, (of residential, industrial, institutional, and commercial
            projects), in the state of Florida.
          </p>
          <p className="mt-4 text-sm text-gray-600 sm:text-base"></p>
          <h3 className="mt-6 text-sm font-bold sm:text-base">
            Independent, licensed, and fully insured.
          </h3>
          <p className="mt-2 text-sm text-gray-600 sm:text-base">
            Our firm is fully licensed, and insured professional general
            contractors, who specialize in the construction service department,
            and principally in the restoration of exterior building envelopes.
            Our contracting firm has worked on and restored some of the most
            prestigious, architecturally challenging, heritage properties,
            within the provinces and states, mentioned above. Our firm is in
            business to perform the very best service for our clients, and help
            our clients achieve a clear and concise understanding of the
            benefits of the restoration work, performed to their building. Our
            goal is to serve people as honestly, as practically, and as
            efficiently as possible, in order to achieve a long-term
            relationship with our clientele.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="hidden md:block lg:w-1/2 aspect-[0.8]">
          <img
            src="https://storage.googleapis.com/wbf-static/storage/vs37j5S/c9d8640fb11e5acfbd7dda9c9ed8cc4f.png"
            className="h-full w-full max-w-md rounded-lg object-cover md:ml-auto shadow-lg lg:rotate-[0.00deg]"
          />
        </div>
      </div>
    </section>
  );
}
